import React, { useContext } from 'react';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { transparentize, darken } from 'polished';
import { Link } from '../link';
import breakpoints from '../../util/breakpoints';
import { PageContext } from '../../context/page-context';

const ActiveMarker = styled('div', {shouldForwardProp: prop => isPropValid(prop)})(props => ({
  width: `10px`,
  marginRight: `0px`,
  backgroundColor: props.active ? props.theme.primary : `transparent`
}));

const StyledNavItem = styled(Link, {shouldForwardProp: prop => isPropValid(prop)})(props => ({
  width: `100%`,
  minHeight: `35px`,
  display: `flex`,
  justifyContent: `flex-start`,
  alignItems: `center`,
  color: props.active ? `white` : darken(0.33, `white`),
  textTransform: `uppercase`,
  borderBottom: props.secondary ? `1px solid #121212` : `1px solid rgba(0,0,0,.3)`,
  cursor: `pointer`,
  textDecoration: `none`,
  padding: `0px 5px`,
  [breakpoints.sm]: {
    fontSize: `12px`
  },

  [`:hover`]: {
    backgroundColor: props.theme.primary,
    color: `white`,
    [`.game-icon`]: {
      filter: `grayscale(0%)`,
      opacity: 1
    }
  },
  opacity: props.secondary ? 0.85 : 1,
  // eslint-disable-next-line no-nested-ternary
  background: props.active
    ? `linear-gradient(to right,  ${transparentize(
        0.5,
        props.theme.primary
      )} 16%, 50%, ${transparentize(0.99, props.theme.primary)})`
    : props.primary
    ? `rgba(0,0,0,.5)`
    : `transparent`
}));

const GameIcon = styled.img(props => ({
  width: `30px`,
  height: `30px`,
  borderRadius: `5px`,
}));

const NavItem = ({ title, primary, iconURI, to, secondary, active }) => {
  const { logEvent } = useContext(PageContext);
  return (
    <StyledNavItem
      primary={primary}
      secondary={secondary}
      onClick={() => {
        logEvent('sidebar_link_click', { to });
      }}
      to={to}
      active={active}
    >
      {iconURI && <GameIcon className="game-icon" src={iconURI}  alt={`${title} icon`} />}
      <ActiveMarker />
      <span>{title}</span>
    </StyledNavItem>
  );
};

export default NavItem;
